import { setupIonicReact } from '@ionic/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createWeb3Modal } from '@web3modal/wagmi/react';
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router } from "react-router-dom";
import { WagmiProvider, http } from 'wagmi';
import { bsc, bscTestnet, mainnet, polygon, polygonMumbai, sepolia } from 'wagmi/chains';
import Translator from './Components/dash/layout/Translator';
import ScrollToTop from './Contexts/ScrollToTop';
import { AppStateProvider } from './Contexts/appStateContext';
import { UserAuthProvider } from './Contexts/authContext';
import Layout from './Routers/Layout';
import appConfig from './Utility/Config/config';

setupIonicReact();

function App() {
  const queryClient = new QueryClient();
  const projectId = appConfig.walletConnectKey;

  const metadata = {
    name: appConfig.appName,
    description: appConfig.appDescription,
    url: appConfig.appLink,//appConfig.appLink, // origin must match your domain & subdomain
    icons: ['https://i.ibb.co/71PQWg5/logoonly.png']
  };

  const chains = [ appConfig.testnet ? bscTestnet : bsc ]
  const config = defaultWagmiConfig({
    chains, // required
    projectId, // required
    metadata, // required
    enableWalletConnect: true, // Optional - true by default
    enableInjected: true, // Optional - true by default
    enableEIP6963: true, // Optional - true by default
    enableCoinbase: true, // Optional - true by default
    // enableEmail: true,
    transports: {
      [bsc.id]: http('https://quaint-alien-valley.bsc.quiknode.pro/4e97660451fc9060ebd399536f8d3e0925cb414f/'),
      [bscTestnet.id]: http('https://bold-misty-thunder.bsc-testnet.quiknode.pro/2e47f29249ec2044358b04e737e2438b16a753ea/'),
    }
  });

  createWeb3Modal({
    wagmiConfig: config,
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration
    themeMode: 'light',
    themeVariables: {
      "--w3m-accent": '#194399'
    }
  });

  return (
    <AppStateProvider>
      <UserAuthProvider>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <Router>
              <ScrollToTop />
              <Layout />
            </Router>
            <Toaster position="top-right" toastOptions={{
              className: '',
              style: {
                border: '1px solid #222',
                background: 'rgba(18, 52, 120)',
                color: '#fff',
                fontSize: '16px',
                padding: '13px 20px',
              },
            }}/>
          </QueryClientProvider>
        </WagmiProvider>
      </UserAuthProvider>
      <Translator />
    </AppStateProvider>
  );
}
export default App;